import React from 'react';
import PropTypes from 'prop-types';

import { ButtonLinkWidget } from '@glowforge/gf-styled/contentful-widgets';

import {
  Heading,
  ImageWrapper,
  Paragraph,
  TextWrapper,
  Wrapper,
} from './catalog.styles';

const Catalog = ({ button, title, bodyContent, image }) => (
  <Wrapper variant='full' className='fullWidth'>
    <TextWrapper>
      <Heading>{title}</Heading>
      <Paragraph>{bodyContent}</Paragraph>
      <ButtonLinkWidget model={button} />
    </TextWrapper>
    <ImageWrapper image={image} />
  </Wrapper>
);

Catalog.propTypes = {
  button: PropTypes.shape({}).isRequired,
  title: PropTypes.string.isRequired,
  bodyContent: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
};

export default Catalog;
